// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PropertyList_wrapper__1GAoK","property":"PropertyList_property__3uE6f","value":"PropertyList_value__HlzeX","label":"PropertyList_label__3Bvjp"};